import { db } from '../db';

/**
 * Empties the phone's copies of the farm's reference lists (orchards, pests)
 * so the next person to sign in on this phone never sees another farm's lists.
 *
 * Never touches unsent work: the scouting queue, drafts and photos stay.
 * (Nothing that uploads reads these two tables, so they are safe to clear.)
 */
export async function clearScoutingReferenceCopies(): Promise<void> {
  await db.orchards.clear();
  await db.pests.clear();
}
